import React, { useState, useEffect } from "react"
import { motion } from "framer-motion"

import { SectionWrapper } from "../../components"
import { urlFor, client } from "../../client"
import "./Skills.scss"
import { Progress } from "rsuite"
import "rsuite/dist/rsuite.min.css"

interface Skill {
	name: string
	bgColor: string
	icon: string
	level: number
	_id: string
}

interface Works {
	name: string
	company: string
	desc: string
	desc_es: string
	_id: string
}

interface Experience {
	since: string
	until: string
	year: string
	works: Works[]
	_id: string
}

const Skills = () => {
	const [skills, setSkills] = useState([] as Skill[])
	const [experiences, setExperiences] = useState([] as Experience[])

	useEffect(() => {
		const skillsQuery = '*[_type == "skills"]'
		const query = '*[_type == "experiences"]'

		client.fetch(query).then((data) => {
			setExperiences(data)
		})

		client.fetch(skillsQuery).then((data) => {
			setSkills(data)
		})
	}, [])
	console.log(skills)

	const formatDate = (date: string) => {
		const newDate = new Date(date)
		return `${String(newDate.getUTCMonth() + 1).padStart(2, "0")}/${newDate.getFullYear()}`
	}

	return (
		<>
			<h2 className='head-text'>Skills & Experience</h2>
			<div className='app__skills-container'>
				<motion.div className='app__skills-list'>
					{skills
						.sort((a, b) => (a.level > b.level ? -1 : 1))
						.map((skill) => (
							<div key={`container-${skill._id}`} className='app__skils-item-container app__flex'>
								<motion.div whileInView={{ opacity: [0, 1] }} transition={{ duration: 0.5 }} className='app__skills-item app__flex'>
									<div className='app__flex' style={{ backgroundColor: skill.bgColor || "#edf2f8" }}>
										<img src={urlFor(skill.icon).toString()} alt={skill.name} />
									</div>
									<p className='p-text'>{skill.name}</p>
								</motion.div>
								{skill.level && <Progress.Line className='app__skills-progressbar' percent={skill.level * 10} vertical={true} />}
							</div>
						))}
				</motion.div>
				<div className='app__skills-exp'>
					{experiences.map((experience) => (
						<motion.div className='app__skills-exp-item' key={experience._id}>
							<div className='app__skills-exp-year'>
								<p className='bold-text'>
									{formatDate(experience.since)} - {experience.until ? formatDate(experience.until) : "present"}
								</p>
							</div>
							<motion.div className='app__skills-exp-works'>
								{experience.works.map((work) => (
									<>
										<motion.div whileInView={{ opacity: [0, 1] }} transition={{ duration: 0.5 }} className='app__skills-exp-work' data-tip data-for={work.name} key={work._id}>
											<h4 className='bold-text'>{work.name}</h4>
											<p className='p-text'>{work.company}</p>
											<p className='p-text'>{work.desc}</p>
											<p className='p-text' style={{ marginTop: 10, fontStyle: "italic" }}>
												{work.desc_es}
											</p>
										</motion.div>
									</>
								))}
							</motion.div>
						</motion.div>
					))}
				</div>
			</div>
		</>
	)
}

export default SectionWrapper(Skills, "skills", "app__whitebg")
